import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { GlobalService } from "../../services/global.service";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
import { UploadService } from "src/app/services/upload.service";
import { ActivatedRoute } from "@angular/router";
import { StorageService } from "../../services/storage.service";

@Component({
  selector: "app-my-profile",
  templateUrl: "./my-profile.component.html",
  styleUrls: ["./my-profile.component.css"],
})
export class MyProfileComponent implements OnInit {
  submitted = false;
  profileForm: FormGroup;
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  updatepro: any;
  getpro: any;
  pro_id: any;
  colbut = false;
  logo: any;
  // preview_image: any;
  // pre_logo: any;

  constructor(
    private storageService: StorageService,
    public globalService: GlobalService,
    public fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: UploadService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (this.route.queryParams["value"].loginType == "impersonate") {
      this.roleID = this.ls.get("impersonate_role");
    }
    this.profileForm = this.fb.group({
      id: [""],
      first_name: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)],
      ],
      last_name: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)],
      ],
      email_address: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$"),
        ],
      ],
      username: ["", Validators.required],
      name: ["", this.roleID === 2 ? Validators.required : ""],
      mobilenumber: ["", Validators.required],
    });
    this.getProfile();
  }

  get f() {
    return this.profileForm.controls;
  }
  async updateProfile(form: FormGroup) {
    this.submitted = true;
    if (this.profileForm.invalid) {
      return;
    }
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id:
        this.storageService.getRole() == 1 ? "0" : this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      first_name: form.value.first_name,
      last_name: form.value.last_name,
      email_address: form.value.email_address,
      name: form.value.name,
      username: form.value.username,
      mobile_number: form.value.mobilenumber,
      id: this.pro_id,
    };
    this.updatepro = await this.globalService.create("user/update", filter);
    this.profileForm.reset();
    this.submitted = false;
    if (this.updatepro["status"] === 200) {
      Swal.fire("Success!", this.updatepro["message"], "success");

      this.getProfile();
    }
    this.spinner.hide();
  }

  async getProfile() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id:
        this.storageService.getRole() == 1 ? "0" : this.ls.get("vendor_id"),
    };
    this.getpro = await this.globalService.get("user/get", filter);
    let comp_details = this.getpro["content"];

    if (this.getpro["status"] === 200) {
      this.profileForm.controls["id"].setValue(comp_details.id);
      this.profileForm.controls["first_name"].setValue(comp_details.first_name);
      this.profileForm.controls["last_name"].setValue(comp_details.last_name);
      this.profileForm.controls["email_address"].setValue(
        comp_details.email_address
      );
      this.profileForm.controls["mobilenumber"].setValue(
        comp_details.mobile_number
      );
      this.profileForm.controls["username"].setValue(comp_details.username);
      this.pro_id = comp_details.id;
      this.logo = comp_details.college_profile;
      // this.preview_image = this.commonService.generateAwsFileUrl(
      //   this.logo + ""
      // );
      // this.pre_logo = this.preview_image.s3_url;
    }
    if (comp_details.college_profile) {
      this.colbut = true;
      this.profileForm.controls["name"].setValue(
        comp_details.college_profile.name
      );
    }
    this.spinner.hide();
  }
}
